import { isTauri } from '@tauri-apps/api/core'
import * as Os from '@tauri-apps/plugin-os'
import { match, P } from 'ts-pattern'
import { OS } from 'ua-parser-js/enums'

import { userAgent } from '@root/shared/lib/dom/user-agent'

type OsType = Os.OsType | 'unknown'
export type PlatformInfo = {
  os: OsType
  version: string | undefined
}

const getBrowserPlatformInfo = (): PlatformInfo => ({
  os: match(userAgent.getOS().name)
    .returnType<OsType>()
    .with(OS.ANDROID, () => 'android')
    .with(OS.IOS, () => 'ios')
    .with(OS.MACOS, () => 'macos')
    .with(OS.WINDOWS, () => 'windows')
    .with(OS.LINUX, () => 'linux')
    .with(P.nullish, () => 'unknown')
    .otherwise(() => 'linux'),
  version: userAgent.getOS().version,
})

export const platformInfo: PlatformInfo = isTauri()
  ? {
      os: Os.type(),
      version: Os.version(),
    }
  : getBrowserPlatformInfo()
